import { Color, CustomChartConfiguration } from '../types/ng-charts.type';
import _ from 'lodash';

/***
 * Configuration file including
 * colors to be used by charts (these are used within the chartConfiguration constant
 * configuration for different chart types: bars (horizontal, vertical), doughnut, and pie
 * options - chart types including Bar-Horizontal, Bar-Vertical, Doughnut, and Pie
 */
// https://stackoverflow.com/questions/42095640/ng2-charts-setting-colors-not-working
const colorConfigurationsBaseSet: Color = {
  backgroundColor: [
    '#a289dc',
    '#b5d3ff',
    '#ffef9a',
    '#a1e4e2',
    '#472c9b',
    '#054fff',
    '#c18600',
    '#009895',
    '#7a57cd',
    '#6c99ff',
    '#f6a526',
    '#42c9c5',
    '#bdabe6',
    '#84b6ff',
    '#fff6c5',
    '#7bd9d6',
    '#5d3cba',
    '#0659ff',
    '#f59d1f',
    '#2bb5b0'
  ]
};

const colorConfigurationsMultiSet: Color = multiplyBackgroundColorConfiguration(3);

export const chartConfigurations: { [key: string]: CustomChartConfiguration } = {
  'bar-horizontal': {
    chartType: 'bar',
    color: colorConfigurationsMultiSet,
    legend: false,
    options: {
      indexAxis: 'y',
      layout: {
        padding: 20
      },
      responsive: true,
      maintainAspectRatio: false,
      scales: {
        x: {
          suggestedMax: 1,
          ticks: {
            stepSize: 1
          }
        }
      }
    }
  },
  'bar-vertical': {
    chartType: 'bar',
    color: colorConfigurationsMultiSet,
    legend: false,
    options: {
      indexAxis: 'x',
      responsive: true,
      maintainAspectRatio: false,
      scales: {
        y: {
          suggestedMax: 1,
          ticks: {
            stepSize: 1
          }
        }
      }
    }
  },
  doughnut: {
    chartType: 'doughnut',
    color: colorConfigurationsMultiSet,
    legend: true,
    options: {
      indexAxis: 'x',
      responsive: true,
      maintainAspectRatio: false
    }
  },
  pie: {
    chartType: 'pie',
    color: colorConfigurationsMultiSet,
    legend: true,
    options: {
      indexAxis: 'x',
      responsive: true,
      maintainAspectRatio: false
    }
  }
};

export const chartCanvasNumericConfiguration: { [key: string]: number } = {
  BASE_HEIGHT: 300,
  BASE_NUMBER_OF_CATEGORIES: 10,
  INCREMENT_PER_CATEGORY: 15,
  MAX_NUMBER_FOR_CUSTOM_TICKS: 10,
  NUMBER_OF_TICKS: 10
};

export const chartTypeOptions = ['Bar-Horizontal', 'Bar-Vertical', 'Doughnut', 'Pie'];

function multiplyBackgroundColorConfiguration(times: number): any {
  const colorConfigurationMultiSet = _.cloneDeep(colorConfigurationsBaseSet);

  if (colorConfigurationMultiSet.hasOwnProperty('backgroundColor')) {
    const tempArray: string[] = [];

    for (let i = 0; i < times; i++) {
      tempArray.push(...colorConfigurationMultiSet.backgroundColor);
    }

    colorConfigurationMultiSet.backgroundColor = tempArray;
  }

  return colorConfigurationMultiSet;
}
